import React, { useEffect, useState } from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { ConfiaCarInput, ConfiaCarInputGroup, ConfiaCarInputGroupText, ConfiaCarLabel } from '..'

const ConfiaCarInputPassword = (props) => {
  const { id, placeholder, children, onChange } = props
  const [icon, setIcon] = useState(<FaEyeSlash />)
  const [inputType, setInputType] = useState('password')
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (showPassword) {
      setIcon(<FaEye />)
      setInputType('text')
    } else {
      setIcon(<FaEyeSlash />)
      setInputType('password')
    }
  }, [showPassword])

  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <>
      <ConfiaCarLabel htmlFor={id}>{children}</ConfiaCarLabel>
      <ConfiaCarInputGroup>
        <ConfiaCarInput id={id} type={inputType} placeholder={placeholder} onChange={onChange} />
        <ConfiaCarInputGroupText onClick={() => handleShowPassword()}>
          {icon}
        </ConfiaCarInputGroupText>
      </ConfiaCarInputGroup>
    </>
  )
}

export { ConfiaCarInputPassword }
